// Static fallback data for when network requests fail
// This ensures users always see some packages even if the API is down

import { WebsiteFeature, ServicePreset } from '@/hooks/useWebsiteFeatures';

export const FALLBACK_FEATURES: WebsiteFeature[] = [
  {
    id: "responsive-design",
    name: "Responsive Design",
    description: "Mobile-friendly design that works on all devices",
    category: "basic",
    credit_cost: 0,
    is_active: true,
    display_order: 1,
    created_at: "",
    updated_at: ""
  },
  {
    id: "contact-form",
    name: "Contact Form",
    description: "Professional contact form with email notifications",
    category: "basic",
    credit_cost: 3,
    is_active: true,
    display_order: 10,
    created_at: "",
    updated_at: ""
  },
  {
    id: "social-media-links",
    name: "Social Media Links",
    description: "Links to your social media profiles",
    category: "basic",
    credit_cost: 1,
    is_active: true,
    display_order: 12,
    created_at: "",
    updated_at: ""
  },
  {
    id: "image-gallery",
    name: "Image Gallery",
    description: "Professional photo gallery with lightbox",
    category: "basic",
    credit_cost: 4,
    is_active: true,
    display_order: 13,
    created_at: "",
    updated_at: ""
  },
  {
    id: "testimonials",
    name: "Testimonials Section",
    description: "Customer reviews and testimonials display",
    category: "basic",
    credit_cost: 3,
    is_active: true,
    display_order: 14,
    created_at: "",
    updated_at: ""
  },
  {
    id: "seo-optimization",
    name: "SEO Optimization",
    description: "Search engine optimization setup",
    category: "marketing",
    credit_cost: 8,
    is_active: true,
    display_order: 50,
    created_at: "",
    updated_at: ""
  }
];

export const FALLBACK_PRESETS: ServicePreset[] = [
  {
    id: "basic-landing-page",
    name: "Basic Landing Page",
    description: "Traditional market price $400-800. Savings: 75-88%. Perfect for portfolios and simple landing pages.",
    feature_ids: ["responsive-design", "contact-form", "social-media-links", "testimonials", "seo-optimization"],
    total_credits: 99,
    traditional_price_usd: 40000,
    estimated_delivery_days: 2,
    display_order: 1,
    is_active: true,
    show_on_landing: true,
    created_at: "",
    updated_at: ""
  },
  {
    id: "advanced-landing-page",
    name: "Advanced Landing Page",
    description: "Everything in Basic plus enhanced features for growing businesses",
    feature_ids: ["responsive-design", "contact-form", "social-media-links", "image-gallery", "testimonials", "seo-optimization"],
    total_credits: 499,
    traditional_price_usd: 120000,
    estimated_delivery_days: 2,
    display_order: 2,
    is_active: true,
    show_on_landing: true,
    created_at: "",
    updated_at: ""
  },
  {
    id: "ecommerce-store",
    name: "E-Commerce Store",
    description: "Complete online store with payment processing and inventory management",
    feature_ids: ["responsive-design", "contact-form", "social-media-links", "image-gallery", "testimonials", "seo-optimization"],
    total_credits: 1999,
    traditional_price_usd: 350000,
    estimated_delivery_days: 7,
    display_order: 3,
    is_active: true,
    show_on_landing: true,
    created_at: "",
    updated_at: ""
  }
];